export enum AdmissionProcedureFieldsMaxLengthEnum {
  procedureCodeItem = 10,
  procedureDescription = 150,
  procedureCount = 3,
  procedureCountAuthorized = 3
}  